import React from "react";
import styles from "./NoPage.module.css";

const NoPage = () => {
    return (
        <div className={styles.container}>
            <h1>404: Page Not Found</h1>
        </div>
    );
};

export default NoPage;
